<app-cadastro-cliente [somenteAbaCliente]="true"></app-cadastro-cliente>